export default __webpack_public_path__ + "static/media/portalone_login_bg.1ee6503c.jpg";